/**
 * Created by iamso on 09.11.18.
 */

const GoalsView = cc.Node.extend({
    ctor: function () {
        this._super();
        GoalViewFactory.init();

        this.game = Game.currentGame;

        this.setLocalZOrder(15);
        this.setAnchorPoint(0.5, 0.5);

        this.setGoals();

        if (!this.game.hasDanger()) {
            this.setBackground();
        }

        this.onResize();

        this.game.goals.on("showUpAnimationStart", this.onShowUpAnimationStart.bind(this), this);
        this.game.goals.on("stopShowUp", this.showUpAnimationFinish.bind(this), this);

        this.game.goals.onGetView = this.createListener(() => this);
    },

    animateHighlight: function (callback) {
        const actions = this.views.map((view) => function (f) {
            view.highlight();
            setTimeout(f, 500);
        });
        new ActionPlayer(actions).play(callback);
    },

    onShowUpAnimationStart: function (callback, silent) {
        if (this.game.bonusLevelCounter) {
            callback();
            return;
        }

        if (silent) {
            this.views.forEach((view) => {
                view.setVisible(true);
            });
            callback();
            return;
        }

        this.runAction(new cc.DelayTime(cleverapps.styles.GoalsView.startAnimation.delay).setFinalize(() => {
            this.showUpAnimationFinish();
            callback();
        }));

        this.createCarAnimation();
        this.createStartAnimation();
    },

    createStartAnimation: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const styles = cleverapps.styles.GoalsView.startAnimation;
        const baseScale = styles.messagesScale[cleverapps.resolution.mode] / this.scale;
        let availableWidth = styles.width;

        this.views.forEach((view) => {
            view.upForStartAnimation();
            availableWidth -= view.width;
        });

        const margins = this.views.length + 1;
        const margin = availableWidth / margins;

        const startAnimation = this.startAnimation = new cleverapps.Layout(this.views, {
            direction: cleverapps.UI.HORIZONTAL,
            margin
        });

        startAnimation.setAlignment(scene.width / 2 + styles.goals.x * baseScale, scene.height / 2 + styles.goals.y * baseScale);
        startAnimation.setScale(styles.action.scale);
        startAnimation.setLocalZOrder(7);

        scene.addChild(startAnimation);

        this.runStartAnimationAction();

        const count = this.views.length;
        const stopAction = cleverapps.wait(count, this.removeStartAnimation.bind(this));

        if (this.game.hasDanger()) {
            this.dangerStartAnimation();
            return;
        }

        this.views.forEach((view) => {
            view.runAction(new cc.Sequence(
                new cc.DelayTime(1.5),
                new cc.CallFunc(() => {
                    const targetPosition = this.goalsLayout.convertToWorldSpace(view.originalPosition);
                    const offset = styles.goals.flyOffset[cleverapps.resolution.mode];
                    targetPosition.x += offset.x;
                    targetPosition.y += offset.y;
                    const points = cc.CollectAnimation.calc3Points(view, targetPosition);

                    view.runStartAnimation(stopAction, points, { x: this.scaleX * this.parent.scaleX, y: this.scaleY * this.parent.scaleY });
                })
            ));
        });
    },

    dangerStartAnimation: function () {
        this.startAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(1.4),
            cleverapps.effects.fireAction("match3.goals.fly"),
            new cc.ScaleTo(0.2, 0).easing(cc.easeBackIn()),
            new cc.CallFunc(this.removeStartAnimation.bind(this))
        ));
    },

    runStartAnimationAction: function () {
        const styles = cleverapps.styles.GoalsView.startAnimation;
        const baseScale = styles.messagesScale[cleverapps.resolution.mode] / this.scale;

        this.startAnimation.setVisible(false);
        this.startAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(styles.action.delay),
            new cc.Show(),
            cleverapps.effects.fireAction("match3.goals.show"),
            new cc.Spawn(
                new cc.ScaleTo(0.25, 1.0).easing(cc.easeIn(2)),
                new cc.MoveBy(0.25, cc.p(0, styles.goals.y * baseScale))
            ),
            new cc.ScaleTo(0.1, 1.1, 0.9),
            new cc.ScaleTo(0.1, 1.0)
        ));
    },

    removeStartAnimation: function () {
        this.views.forEach((view) => {
            view.downFromStartAnimation();
        });

        if (this.startAnimation) {
            this.startAnimation.stopAllActions();
            this.startAnimation.removeFromParent();
            delete this.startAnimation;
        }
    },

    createCarAnimation: function () {
        const styles = cleverapps.styles.GoalsView.startAnimation;
        const scene = cleverapps.Scenes.GetRunningScene();

        const baseScale = styles.scales[cleverapps.resolution.mode];
        const carAnimation = this.carAnimation = new cleverapps.Spine(bundles.game.jsons.start_level_animation_json);
        carAnimation.setScale(baseScale || 1.0);
        carAnimation.setAlignment(scene.width / 2, scene.height / 2 + styles.car.offsetY);
        carAnimation.setLocalZOrder(7);
        scene.addChild(carAnimation);

        carAnimation.setCompleteListenerRemove();
        carAnimation.runAction(new cc.CallFunc(() => {
            carAnimation.setAnimation(0, "animation", false);
        }));

        cleverapps.effects.fire("match3.episode.car");
    },

    hide: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const targetPosition = this.getPosition();
        switch (cleverapps.resolution.mode) {
            case cleverapps.WideMode.VERTICAL: case cleverapps.WideMode.SQUARE:
                targetPosition.y = scene.height + this.height + 2;
                break;
            case cleverapps.WideMode.HORIZONTAL:
                targetPosition.x = -this.width - 2;
                break;
        }

        this.runAction(new cc.MoveTo(0.15, targetPosition).easing(cc.easeIn(2)).setFinalize(() => {
            this.setAlignment(targetPosition);
            this.setVisible(false);
        }));
    },

    showUpAnimationFinish: function () {
        if (this.game.bonusLevelCounter) {
            return;
        }

        this.views.forEach((view) => {
            view.setVisible(true);
        });
    },

    onResize: function () {
        if (this.startAnimation) {
            this.removeStartAnimation();
        }

        this.views.forEach((view) => {
            view.stopAllActions();
        });

        if (this.carAnimation) {
            this.carAnimation.removeFromParent();
            delete this.carAnimation;
        }

        this.setContentSize2(this.getSize());

        const styles = cleverapps.styles.GoalsView;

        if (this.background) {
            this.background.setContentSize2(this.getSize());
            this.background.setAlignment(styles.background);
        }

        if (this.bgTitle) {
            this.bgTitle.setAlignment(styles.bgTitle.position[cleverapps.resolution.mode]);
            this.bgTitle.setScale(1);
            const sizeStyles = styles.bgTitle.position[cleverapps.resolution.mode];
            if (sizeStyles.scale) {
                this.bgTitle.setScale(sizeStyles.scale);
            }
        }

        let positionStyles = this.game.lightingRushMission ? styles.positionWithMission : styles.positionNoMission;

        if (this.game.hasDanger()) {
            positionStyles = styles.positionDangerLevel;
        }

        let position = positionStyles[cleverapps.resolution.mode];
        if (Array.isArray(position)) {
            position = position[this.views.length - 1];
        }
        this.setAlignment(position);
        this.updateGoalsPosition();
    },

    getSize: function () {
        const sizes = (this.game.lightingRushMission) ? cleverapps.styles.GoalsView.sizes.withMission : cleverapps.styles.GoalsView.sizes.noMission;

        if (this.game.hasDanger()) {
            return cleverapps.styles.BaseGoalView.danger;
        }

        if (cleverapps.environment.isAdministratorScene()) {
            return sizes[cleverapps.WideMode.VERTICAL];
        }

        return sizes;
    },

    setBgTitle: function () {
        this.bgTitle && this.bgTitle.removeFromParent(true);
        const styles = cleverapps.styles.GoalsView.bgTitle;
        if (styles) {
            const bgTitle = this.bgTitle = new cc.Sprite(bundles.game.frames.goals_title);
            const text = cleverapps.UI.generateOnlyText(Messages.get("Goals.title"), cleverapps.styles.FONTS.GOALS_TITLE);
            text.setAlignment(bgTitle.width / 2, bgTitle.height / 2 + styles.text.offsetY);
            bgTitle.addChild(text);

            this.addChild(bgTitle);
        }
    },

    setBackground: function () {
        const image = bundles.game.frames.goal_common_bg;
        if (!image) {
            return;
        }

        this.background = cleverapps.UI.createScale9Sprite(image);
        this.background.setLocalZOrder(-1);
        this.addChild(this.background);

        if (cleverapps.styles.COLORS.HARD && this.game.level.isHard()) {
            this.background.setColor(cleverapps.styles.COLORS.HARD);
        }

        this.setBgTitle();
    },

    setGoals: function () {
        this.views = [];
        let id = 0;
        Object.values(this.game.goals.elements).forEach((element) => {
            const view = GoalViewFactory.createView(element);
            view.setLocalZOrder(cleverapps.styles.GoalsView.zOrders[id]);
            this.views.push(view);

            element.checkCompleted();
            view.update();

            element.getView = function () {
                return view;
            };

            id++;
        });
    },

    updateGoalsPosition: function () {
        const styles = cleverapps.styles.GoalsView.goalsLayout;
        let direction = cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL ? cleverapps.UI.VERTICAL : cleverapps.UI.HORIZONTAL;

        let scale;
        if (styles.scales && styles.scales[cleverapps.resolution.mode]) {
            if (Array.isArray(styles.scales[cleverapps.resolution.mode])) {
                scale = styles.scales[cleverapps.resolution.mode][this.views.length - 1] || false;
            } else {
                scale = styles.scales[cleverapps.resolution.mode];
            }
        }

        if (cleverapps.environment.isAdministratorScene()) {
            direction = cleverapps.UI.HORIZONTAL;
        }

        const side = direction === cleverapps.UI.VERTICAL ? "height" : "width";

        let originalSize = 0;
        this.views.forEach((view) => {
            if (scale) {
                view.setScale(scale);
            }

            originalSize += view[side] * view.scale;
        });

        const layoutOptions = {
            direction,
            margin: (this[side] - originalSize) / (this.views.length)
        };

        if (!this.goalsLayout) {
            this.goalsLayout = new cleverapps.Layout(this.views, layoutOptions);
            this.addChild(this.goalsLayout);
        } else if (this.goalsLayout.options.direction !== direction) {
            layoutOptions.reversed = cleverapps.config.rpg;
            this.goalsLayout.setOptions(layoutOptions);
        }

        this.goalsLayout.setAlignment(styles);
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    GOALS_TITLE: {
        size: 22,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.GoalsView = {
    zOrders: [3, 3, 3],

    background: {
        x: { align: "center" },
        y: { align: "center" }
    },

    goalsLayout: {
        x: { align: "center" },
        y: { align: "center" }
    },

    startAnimation: {
        delay: 2.5,
        action: {
            scale: 0.1,
            delay: 0.25
        },
        width: 520,
        goals: {
            scale: [1.0, 1.2, 1.3],
            x: 0,
            y: 0,
            flyOffset: [
                { x: 0, y: 0 },
                { x: 0, y: 0 },
                { x: 0, y: 0 }
            ]
        },

        car: {
            offsetY: -20
        },

        messagesScale: [0.8, 1, 1],
        scales: [0.8, 1, 1]
    }
};
